class TreasureChest {

    constructor(chestElement) {

        const t = this;

        this.chestElement = chestElement;

        this.lockedIcon =  this.chestElement.find('.icon-without-link');
        this.unlockedIcon = this.chestElement.find('.treasure-chest-submit');
        this.openedIcon = this.chestElement.find('.opened-icon');

        this.unlockedIcon.on('click', function() { t.open($(this)); });
    }


    unlock(canOpen = true, changeText = true) {
        // Unlock the chest - set unlocked icon
        this.setUnlockedIcon();

        // Change info text to "Ready"
        if(changeText) { this.setRewardInfoText('readyText'); }

        if(canOpen == false) 
        { 
            this.unlockedIcon.off('click'); 
            this.chestElement.removeClass('ready');
        }

    }


    open(chestSubmitLink) {
        this.unlock(false, false);
        this.sendOpenChestPost(chestSubmitLink.attr('data-href'));
    }

    sendOpenChestPost(link) {

        const t = this;

        $.post(
            link, 
            {},
            function(data) {
              
                if(!data['success']) { return; }
    
                const {xpRequirements, xpInfo, xpToAdd} = data;
    
                t.unlockedIcon.css('display', 'block').show();
                t.unlockedIcon.addClass('open-animation');

                setTimeout(() => {
                    t.setOpenedIcon();
                    t.setRewardInfoText('openedText', xpToAdd);

                    (new XpBar()).animate(xpRequirements, xpInfo, xpToAdd);

                    t.addAnimatedNumber(xpToAdd);

                }, 690);

            }
        );
    }

    addAnimatedNumber(xpToAdd) {
        
        const animatedNumberText = xpToAdd + " " + localizedTexts.games.xp.xpShortcut;

        new AnimatedNumber(
            this.chestElement, 
            "treasure-amount-to-add-span", 
            animatedNumberText, 
            {top: -15, left: 0, right: -50}
        )
            .animate(
                {
                    top: "-70px",
                    right: "-70px",
                }
            );
    }


    setRewardInfoText(textType, xpToAdd = null) 
    {
        const rewardContainer = this.chestElement.closest('.reward-container');
        const infoTextElement = rewardContainer.find('.info-text');

        let text = infoTextElement.attr(`data-${textType}`);
        
        if(xpToAdd !== null && textType === 'openedText') 
        {
            text = 
                infoTextElement.attr('data-openedText1') + 
                ' <span class="text-color-blue font-bold">+' + xpToAdd + " " + localizedTexts.games.xp.xpShortcut + '</span> ' +
                infoTextElement.attr('data-openedText2');
        }

        $(infoTextElement).html(text);
    }


    setLockedIcon() {
        this.chestElement.removeClass('ready opened').addClass('locked');  

        this.openedIcon.hide();
        this.unlockedIcon.hide();

        this.lockedIcon.show();
    }

    setUnlockedIcon() {
        this.chestElement.removeClass('locked opened').addClass('ready');  

        this.openedIcon.hide();
        this.lockedIcon.hide();
        
        this.unlockedIcon.show();
    }

    setOpenedIcon(animation = true) {
        this.chestElement.removeClass('locked ready').addClass('open');   

        this.lockedIcon.hide();
        this.unlockedIcon.hide(); 

        if(animation) { new Animations().fadein(this.openedIcon, 300); }
        else { this.openedIcon.show(); }

    }

}